export const features = [
  {
    title: "Mobile Service",
    description: "We come to your location anywhere in the Twin Cities metro",
  },
  {
    title: "Professional Team",
    description: "Experienced and certified Twin Cities detailers",
  },
  {
    title: "Quality Products",
    description: "Premium-grade detailing materials for Minnesota's climate",
  },
  {
    title: "Satisfaction Guaranteed",
    description: "100% satisfaction or your money back, trusted throughout Minneapolis-St. Paul",
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-20 bg-primary-light animate-on-scroll opacity-0">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-white text-center mb-12">
          Why Choose Us
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="text-center p-6 bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow"
            >
              <h3 className="text-xl font-semibold text-primary mb-3">
                {feature.title}
              </h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
